import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { NavigationService } from '../../../shared/services/navigation.service';
import { ThemeService } from '../../services/theme.service';
import { Subscription } from 'rxjs';
import { ILayoutConf, LayoutService } from '../../../shared/services/layout.service';
import { JwtAuthService } from '../../../shared/services/auth/jwt-auth.service';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-sidebar-side',
  templateUrl: './sidebar-side.component.html',
  styleUrls: ['./sidebar-side.component.css']
})
export class SidebarSideComponent implements OnInit, OnDestroy, AfterViewInit {
  public menuItems: any[];
  public hasIconTypeMenuItem: boolean;
  public iconTypeMenuTitle: string;
  private menuItemsSub: Subscription;
  public layoutConf: ILayoutConf;
  showUpdate = false;

  constructor(
    private navService: NavigationService,
    public themeService: ThemeService,
    private layout: LayoutService,
    public jwtAuth: JwtAuthService,
    private swUpdate: SwUpdate
  ) {}

  ngOnInit() {
    this.iconTypeMenuTitle = this.navService.iconTypeMenuTitle;
    this.menuItemsSub = this.navService.menuItems$.subscribe(menuItem => {
      this.menuItems = menuItem;
      this.hasIconTypeMenuItem = !!this.menuItems.filter(item => item.type === 'icon').length;
    });
    this.layoutConf = this.layout.layoutConf;

    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe(evt => {
        switch (evt.type) {
          case 'VERSION_READY':
            console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
            this.showUpdate = true;
            break;
          case 'VERSION_INSTALLATION_FAILED':
            console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
            break;
        }
      });
    }
  }

  reloadApp() {
    this.showUpdate = false;
    document.location.reload();
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    if (this.menuItemsSub) {
      this.menuItemsSub.unsubscribe();
    }
  }

  toggleCollapse() {
    if (this.layoutConf.sidebarCompactToggle) {
      this.layout.publishLayoutChange({
        sidebarCompactToggle: false,
        sidebarStyle: 'full'
      });
    } else {
      this.layout.publishLayoutChange({
        sidebarCompactToggle: true,
        sidebarStyle: 'compact'
      });
    }
  }

  get empresaNomeSessao(): string {
    const item = this.jwtAuth.item$?.value;
    const filial = this.jwtAuth.filial$?.value;

    return item?.empresaRemota?.nomeFantasia
      || filial?.nomeFantasia
      || filial?.razaoSocial
      || '';
  }

  get logoEmpresaSessao(): string | null {
    const item = this.jwtAuth.item$?.value;
    const filial = this.jwtAuth.filial$?.value;

    return item?.empresaRemota?.urlLogo
      || filial?.urlLogo
      || null;
  }
}